import waitForLoad from "../utils/waitForLoad";
var domain = 'https://connect.facebook.net';
/* eslint-disable */

var loadScript = function loadScript(locale) {
  if (window.FB) return false;

  (function loadFacebookSDK(d, s, id) {
    // fetch customerchat.js
    var fjs = d.getElementsByTagName(s)[0];

    if (d.getElementById(id)) {
      return;
    }

    var js = d.createElement(s);
    js.id = id;
    js.src = "".concat(domain, "/").concat(locale, "/sdk/xfbml.customerchat.js");

    if (fjs) {
      var _fjs$parentNode;

      (_fjs$parentNode = fjs.parentNode) === null || _fjs$parentNode === void 0 ? void 0 : _fjs$parentNode.insertBefore(js, fjs);
    } else {
      d.body.appendChild(js);
    }
  })(window.document, 'script', 'facebook-jssdk');

  return true;
};
/* eslint-enable */


var load = function load(_ref) {
  var appID = _ref.appID,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en_US' : _ref$locale,
      setState = _ref.setState,
      _ref$beforeInit = _ref.beforeInit,
      beforeInit = _ref$beforeInit === void 0 ? function () {
    return undefined;
  } : _ref$beforeInit,
      _ref$onReady = _ref.onReady,
      onReady = _ref$onReady === void 0 ? function () {
    return undefined;
  } : _ref$onReady;
  var loaded = loadScript(locale); // Continue as long as messenger hasn’t already been initialised.

  if (loaded) {
    beforeInit();

    window.fbAsyncInit = function () {
      window.FB.init(Object.assign({
        cookie: true,
        xfbml: true,
        version: 'v6.0'
      }, appID ? {
        appId: appID
      } : {}));
      window.FB.Event.subscribe('customerchat.load', function () {
        return (// Allow messenger to complete loading before removing fake widget
          setTimeout(function () {
            setState('complete');
            onReady();
          }, 3000)
        );
      });
    };
  }

  return loaded;
};

var open = function open() {
  waitForLoad(function () {
    var _window$FB, _window$FB$CustomerCh;

    return !!((_window$FB = window.FB) !== null && _window$FB !== void 0 && (_window$FB$CustomerCh = _window$FB.CustomerChat) !== null && _window$FB$CustomerCh !== void 0 && _window$FB$CustomerCh.show);
  }, // messenger is slow to show once it has loaded
  function () {
    return setTimeout(function () {
      return window.FB.CustomerChat.show(true);
    }, 2000);
  });
};

export default {
  domain: domain,
  load: load,
  open: open
};